import { AuthProvider } from 'react-admin';

const apiUrl = process.env.REACT_APP_API_URL || 'https://api.sushismile154.ru';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const request = new Request(`${apiUrl}/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    
    try {
      const response = await fetch(request);
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      const { access_token, user } = await response.json();
      localStorage.setItem('token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      
      // Проверяем, что пользователь - админ
      if (user.role !== 'admin') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        throw new Error('Access denied. Admin only.');
      }
      
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },
  
  checkAuth: () => {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  },
  
  checkError: ({ status }: any) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  
  getPermissions: () => {
    const user = localStorage.getItem('user');
    return user ? Promise.resolve(JSON.parse(user).role) : Promise.reject();
  },
  
  getIdentity: () => {
    try {
      const user = localStorage.getItem('user');
      if (user) {
        const { id, name } = JSON.parse(user);
        return Promise.resolve({ id, fullName: name, avatar: undefined });
      }
    } catch (error) {
      return Promise.reject(error);
    }
    return Promise.reject();
  },
};